<template>
  <v-dialog v-model="dialog" persistent width="800">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline m-0">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{
            form.id
              ? "Editar Programacion"
              : "Crear parámetros para la programacion de vacaciones"
          }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md style="min-width: 100%;" class="py-1">
            <v-layout wrap>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Gestión"
                  v-model="form.gestion"
                  :rules="$validate(['required'])"
                  type="number"
                  required
                  maxlength="200"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Porcentaje de vacaciones a programar (%)"
                  v-model="form.porcentaje"
                  type="number"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Fecha inicio de programación"
                  v-model="form.fecha_inicio"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Fecha fin de programación"
                  v-model="form.fecha_fin"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Días de reserva de la programación"
                  v-model="form.dias_reserva"
                  type="number"
                  :rules="$validate(['required'])"
                  required
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Fecha corte para inicio de programación"
                  v-model="form.fecha_corte"
                  type="date"
                  :rules="$validate(['required'])"
                  required
                  maxlength="200"
                  outline
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  class="text-field-reducido-border"
                  label="Fecha ampliación de programación"
                  v-model="form.fecha_ampliacion"
                  type="date"
                  maxlength="200"
                  disabled
                  outline
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>
          <v-btn @click.native="close()">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" type="submit" :loading="loading">
            <v-icon dark>check</v-icon> {{ $t("common.save") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogCrearActualizarProgramacion", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async save() {
      if (this.$refs.form.validate()) {
        let user = this.$storage.get("user");
        try {
          if (this.form.id) {
            const id = parseInt(this.form.id);
            let respuesta = await this.$service.graphql({
              query: `
				        query{
                	runQuery(consulta:"select vacaciones.fn_actualiza_programacion(${id},${
                this.form.gestion
              },${this.form.porcentaje},'${this.form.fecha_corte}','${
                this.form.fecha_inicio
              }','${this.form.fecha_fin}',${user.id},${parseFloat(
                this.form.dias_reserva
              )})"){
                    	respuesta
                      }
                    }
				        `,
              variables: {
                programacion: this.form
              }
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_actualiza_programacion;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto == "1") {
              this.$alert(resps[1]);
              this.close();
            } else {
              this.$alert(resps[1]);
            }
          } else {
            this.form.gestion = parseInt(this.form.gestion);
            this.form.porcentaje = parseFloat(this.form.porcentaje);
            this.form.id_estado = 59;
            let respuesta = await this.$service.graphql({
              query: `
				        query{
                	runQuery(consulta:"select vacaciones.fn_registra_programacion(${this.form.gestion},${this.form.porcentaje},'${this.form.fecha_corte}','${this.form.fecha_inicio}','${this.form.fecha_fin}',${user.id},${this.form.dias_reserva})"){
                    	respuesta
                      }
                    }
				        `,
              variables: {
                programacion: this.form
              }
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_registra_programacion;
            let resps = respuesta.split("|");
            let correcto = resps[0];
            if (correcto == "1") {
              this.$alert(resps[1]);
              this.close();
            } else {
              this.$alert(resps[1]);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/parametros_vacacion/dialogs/CrearActualizarProgramacion.vue